export default __webpack_public_path__ + "static/media/GC_sign_in_image_ES.720b27dd.png";